import { STATUS_COLORS, STATUS_LABELS } from "@/lib/status";

const fmtTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("es-US", {
    timeZone: "America/New_York",
    day: "2-digit", month: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit",
    hour12: false,
  });
};

export const entryLabel = (e) => {
  const isEdit = !e.status && e.edit_field;
  if (isEdit) return `Editó ${e.edit_label || e.edit_field}`;
  if (e.note === "creado") return "Creado";
  return STATUS_LABELS[e.status] || e.status;
};

// Timeline rows for a trip's `status_history` (creation, status changes,
// driver assignment, per-field edits). Shared by the popover and the
// "Movimientos del viaje" section inside the edit dialog.
export default function StatusHistoryList({ history, loading = false, testId = "status-history-list" }) {
  const rows = Array.isArray(history) ? history : [];
  if (loading && rows.length === 0) {
    return <div className="text-xs text-muted-foreground py-6 text-center" data-testid={`${testId}-loading`}>Cargando movimientos…</div>;
  }
  if (rows.length === 0) {
    return <div className="text-xs text-muted-foreground py-6 text-center" data-testid={`${testId}-empty`}>Sin historial registrado.</div>;
  }
  return (
    <div className="space-y-1" data-testid={testId}>
      {rows.map((e, i) => {
        const isEdit = !e.status && e.edit_field;
        const color = isEdit ? "#F59E0B" : (STATUS_COLORS[e.status] || "#9CA3AF");
        return (
          <div key={`${e.at || "no-ts"}-${e.status || e.edit_field || "row"}-${i}`} className="flex items-start gap-2 rounded-md bg-secondary/30 border border-border/60 px-2 py-1.5" data-testid={`${testId}-row-${i}`}>
            <span className="mt-1 w-2 h-2 rounded-full flex-shrink-0" style={{ background: color }} />
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-1 flex-wrap">
                <span className="text-[11px] font-bold" style={{ color }}>{entryLabel(e)}</span>
                <span className="text-[10px] font-mono text-muted-foreground tabular-nums">{fmtTime(e.at)}</span>
              </div>
              <div className="text-[11px] text-muted-foreground">
                <span className="text-white/80">{e.by_name || "—"}</span>
                {e.by_role ? <span className="ml-1 text-[10px] uppercase tracking-wide">({e.by_role})</span> : null}
              </div>
              {isEdit ? (
                <div className="text-[11px] mt-0.5 font-mono break-words">
                  <span className="text-red-400 line-through">{e.before}</span>
                  <span className="mx-1 text-muted-foreground">→</span>
                  <span className="text-emerald-400">{e.after}</span>
                </div>
              ) : (
                e.note && e.note !== "creado" ? <div className="text-[11px] text-muted-foreground italic truncate">· {e.note}</div> : null
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
